import { render, staticRenderFns } from "./SelectItem.vue?vue&type=template&id=22bf2cf0&scoped=true"
import script from "./SelectItem.vue?vue&type=script&lang=js"
export * from "./SelectItem.vue?vue&type=script&lang=js"
import style0 from "./SelectItem.vue?vue&type=style&index=0&id=22bf2cf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22bf2cf0",
  null
  
)

export default component.exports